export function randomStr(
  len = 20,
  charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
) {
  const arr = charset.split("");
  let result = "";

  for (let i = len; i > 0; i--) {
    result += arr[Math.floor(Math.random() * arr.length)];
  }

  return result;
}

export function handleRPCError(error) {
  const parsedError = JSON.stringify(error.message);

  if (parsedError.includes("execution reverted: ")) {
    const rgx = /(?:execution reverted: )(.*)(?=\\n{)/g;
    const rgxResult = rgx.exec(parsedError);
    return Array.isArray(rgxResult) ? rgxResult[0] : rgxResult;
  }

  if (typeof error.message === "string" || error.message instanceof String) {
    return { message: error.message };
  }

  return "Unknown error";
}
